document.addEventListener('rebuy:cart.change', (event) => {
  const cartIconBubble = document.querySelector('#cart-icon-bubble');
  if (cartIconBubble) {
    const { item_count: itemCount } = event.detail.cart.cart;
    const cartItemsText =
      itemCount === 1
        ? window.languages.cartCount.one
        : window.languages.cartCount.other.replace('-1', itemCount);
    cartIconBubble.setAttribute('aria-label', cartItemsText);
  }
});
